import styled from "styled-components";

const PayrollContentStyles = styled.div`
  section.our-job {
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    ${(props) => props.theme.media.md} {
      padding-left: 0;
      padding-right: 0;
    }

    .title {
      font-size: 2.5rem;
      font-weight: 400;
      margin: 0 auto 1rem;
      text-align: center;
    }

    .subtitle {
      font-size: 18px;
      line-height: 1.2;
      margin: 0 auto 3rem;
      width: 85%;
    }

    .row {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      .left {
        display: flex;
        flex-basis: 100%;
        flex-direction: column;

        ${(props) => props.theme.media.lg} {
          flex-basis: 46%;
        }

        .checkmarks {
          padding: 0;

          .check {
            align-items: start;
            display: flex;
            margin-bottom: 1.5rem;

            img {
              height: auto;
              margin-right: 10px;
              margin-top: 4px;
              width: 20px;
            }

            .check-copy {
              .check-title {
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 0;
              }

              p {
                margin: 0;
              }
            }
          }
        }

        .btn-primary {
          margin: 0 auto 1rem;

          ${(props) => props.theme.media.lg} {
            margin: 0 auto;
          }
        }
      }

      .right {
        flex-basis: 100%;

        ${(props) => props.theme.media.lg} {
          flex-basis: 52%;
        }

        .card-wrapper {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 20px;

          .card {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 2rem 0 1rem;

            img {
              height: 75px;
              margin-bottom: 2rem;
              width: auto;
            }

            p {
              text-align: center;
            }
          }
        }
      }

      &.cta-btn {
        margin-top: 2rem;
        text-align: center;

        ${(props) => props.theme.media.lg} {
          margin-top: 0;
        }
      }
    }
  }

  section.payroll-cards {
    .container {
      ${(props) => props.theme.media.lg} {
        max-width: 90%;
      }
    }

    .cards-section-title {
      display: none;
      font-family: Poppins;
      text-align: center;
      padding-bottom: 60px;
      font-size: 30px;
      margin: auto;
      
      ${(props) => props.theme.media.lg} {
        display: block;
        font-size: 40px;
        width: 100%;
      }
    }
    
    .cards-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      ${(props) => props.theme.media.lg} {
        flex-direction: row;
        justify-content: space-around;
        max-width: 1200px;
        margin: auto;

      }

      .card-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 85%;
        margin-top: 50px;

        ${(props) => props.theme.media.lg} {
          width: 400px;
        }

        .icon-bubble {
          height: 100px;
          width: 100px;
          border-radius: 50%;
          background-color: #FE6600;
          display: flex;
          justify-content: center;

          ${(props) => props.theme.media.lg} {
            margin-bottom: 10px;
          }
        }
  
        .card-icon {
          display: block;
          margin: auto;
        }
  
        .card-title {
          font-family: Poppins;
          font-size: 24px;
          line-height: 28px;
          margin-top: 30px;

          ${(props) => props.theme.media.lg} {
            max-width: 70%;
            margin-top: 10px;
          }
        }

        .card-description {
          max-width: 288px;
          ${(props) => props.theme.media.lg} {
            max-width: 80%;
            text-align: left;
          }
        }
  
      }

      .card-section:first-child {
        .card-icon {
          margin-left: 32px;
        }
      }
    }
  }

  section.consultation {
    .container {
      ${(props) => props.theme.media.lg}{
      }
    }
    .consultation-container {
      display: flex;
      font-family: Poppins;
      ${(props) => props.theme.media.lg} {
        justify-content: space-evenly;
        margin: 0 auto;
      }
    }

    .consultation-image {
      display: none;
      flex: 1 1 0px;
      ${(props) => props.theme.media.lg} {
        display: flex;
        width: 500px;
      }
    }

    .consultation-image-small {
      margin-bottom: 30px;
      ${(props) => props.theme.media.lg} {
        display: none;
      }
    }

    .consultation-text-container {
      display: flex;
      flex-direction: column;
      flex: 1 1 0px;
      ${(props) => props.theme.media.lg} {
        display: block;
        margin-left: 50px;
        max-width: 70%;
      }
    }

    .consultation-title {
      font-size: 30px;
      color: #3F5261;
      margin: auto;
      margin-bottom: 30px;
      line-height: 37px;

      ${(props) => props.theme.media.lg} {
        font-size: 42px;
        line-height: 1;
      }
    }

    .consultation-step {
      padding-right: 20px;
      display: flex;
      align-items: center;
      background-color: #F8F6F4;
      margin-bottom: 9px;
      
      ${(props) => props.theme.media.lg} {
        max-height: 5.5rem;
      }
      
      .consultation-counter {
        text-align: center;
        font-size: 36px;
        padding: 0px 20px;

        ${(props) => props.theme.media.lg} {
          padding: 20px;
          font-size: 38px;
        }
      }

      .consultation-description {
        font-size: 18px;
        line-height: 30px;
        ${(props) => props.theme.media.sm} {
          width: 307px;
        }
        ${(props) => props.theme.media.lg} {
          font-size: 24px;
          width: 80%;
        }
      }
    }

    .consultation-button-container {
      display: flex;
      justify-content: center;
      margin-top: 36px;

      & .btn {
        font-size: 1.22rem;
        @media (min-width: 330px) {
          font-size: 1.3rem;
        }
      }
    }
  }

  section.testimonials {
    .container {
      width: 380px;

      ${(props) => props.theme.media.lg} {
        width: 100%;
      }
    }

    .testimonials-container {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
      overflow-x: scroll;
      overflow-y: visible; 
      width: 100%;
      scroll-snap-type: x mandatory;

      // hide scrollbar on IE, Edge, Firefox
      -ms-overflow-style: none;  
      scrollbar-width: none; 


      ${(props) => props.theme.media.lg} {
        display: flex;
        justify-content: center;
        flex-direction: row;
        overflow: visible;
      }
    }

    // hide scrollbar on Chrome, Opera, Safari
    .testimonials-container::-webkit-scrollbar {
      display: none;
    }

    .testimonial-section {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px;
      width: 350px;
      scroll-snap-align: center;

      ${(props) => props.theme.media.lg}{
        width: 400px;

      }
    }

    .testimonial-section:nth-child(even){
      ${(props) => props.theme.media.lg} {
        border-left: 1px solid lightgray;
        border-right 1px solid lightgray;
        padding-left: 30px;
        padding-right: 30px;
        width: 500px;
      }

      .testimonial-quote {
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 30px;
        font-size: 18px;
      }
    }

    .testimonial-section:nth-child(odd) {
      ${(props) => props.theme.media.lg} {
        .testimonial-quote {
          font-size: 18px;
          max-width: 301px;
          margin: auto;
        }
      }
    }

    .testimonial-image {
      max-height: 140px;
      margin: 30px auto;
    }

    .testimonial-title {
      font-family: Poppins;
      color: #3F5261;
      text-align: center;
      line-height: 1;
      margin-bottom: 30px;
      font-size: 24px;
      
      ${(props) => props.theme.media.lg} {
        font-size: 30px;

      }
    }

    .testimonial-quote {
      font-family: Inter;
      color: #464646;
      font-weight: 300;
      text-align: center;
      margin-bottom: 80px;
      font-size: 16px;
    }

    .testimonial-attribution {
      font-family: Inter;
      color: #464646;
      font-weight: 300;
      text-align: right;
      font-size: 16px;

      ${(props) => props.theme.media.lg} {
        margin-top: 80px;
      }
    }
  }

  section.hiw {
    .container {
      width: 100%;
    }
    .hiw-container {
      background-color: #F8F6F4;
      ${(props) => props.theme.media.lg} {
        border-radius: 50px;

      }
    }

    .hiw-title {
      font-family: Poppins;
      color: #3F5261;
      font-size: 30px;
      text-align: center;
      padding-top: 30px;
      width: 357px;
      margin: auto;
      margin-bottom: 30px;

      ${(props) => props.theme.media.lg} {
        width: 60%;
        margin: auto;
        font-size: 40px;
        padding: 40px;
      }
    }

    .hiw-section {
      margin-top: 30px;
      padding: 10px;
      ${(props) => props.theme.media.lg} {
        padding: 30px;
        margin-top: 0px;
      }
    }
    
    .hiw-section:nth-child(odd) {
      ${(props) => props.theme.media.lg} {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
      }
    }
    
    .hiw-section:nth-child(even) {
      ${(props) => props.theme.media.lg} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .hiw-image-container {
      ${(props) => props.theme.media.lg} {
        max-width: 500px;
      }

      img {
        ${(props) => props.theme.media.lg} {
          max-width: 500px;

        }
      }
    }

    .hiw-text-container {
      ${(props) => props.theme.media.lg} {
        display: flex;
        align-items: center;
      }
    }

    .hiw-text-container:last-child {
      ${(props) => props.theme.media.lg} {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }


    .hiw-section:nth-child(6) {
      .hiw-text {
        h2 {
          font-size: 26px;
        }
        p {
          width: 380px;
        }
      }
    }


    .hiw-text {
      ${(props) => props.theme.media.lg} {
        margin: 30px;
        max-width: 400px;
      }
    

      h2 {  
        margin: 0;
        margin-top: 20px;
        ${(props) => props.theme.media.lg} {
          margin-top: 0px;
          margin-bottom: 10px;
          text-align: left;
          font-size: 28px;

        }
      }

      p {
        text-align: center;
        width: 360px;
        margin: auto;
        ${(props) => props.theme.media.lg} {
          text-align: left;
          width: 375px;
        }
      }

      span {
        ${(props) => props.theme.media.lg} {
          font-size: 16px;
        }
      }
    }

    .button-container {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;

      .btn {
        ${(props) => props.theme.media.lg} {
          margin-top: 20px;\
        }
      }
    }

    .col-md-12 {
      padding: 0;

      ${(props) => props.theme.media.lg} {
        padding-left: 15px;
        padding-right: 15px;
      }
    }

  }

  section.what-you-get {
    ${(props) => props.theme.media.lg} {
      background-color: #EFE7DA;

    }

    .container {
      max-width: 1400px;

      h2 {
        color: #3F5261;
        font-size: 40px;
        font-weight: 400;
        margin-bottom: 60px;
        text-align: center;
      }

      .subtitle {
        margin: 0 auto 2rem;
        text-align: center;
        width: 60%;
      }

      .cards-container {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: 1fr;
        padding: 0 2rem;
        margin: auto;
        
        ${(props) => props.theme.media.lg} {
          width: 75%;
          grid-template-columns: repeat(3, 1fr);
          justify-content: space-evenly;
          padding: 0;
        }

        .card {
          border: none;
          width: 265px;
          margin: auto;
          margin-top: 30px;
          
          ${(props) => props.theme.media.lg} {
            width: 100%;
            margin: 5px;
            padding: 2rem;

          }

          img {
            margin: 0 auto 1rem;
            max-width: 100px;
          }

          .title {
            height: 50px;

            h3 {
              font-size: 1.25rem;
              margin: 0;
              margin-top: 20px;
              line-height: 1.2;
              text-align: center;
              font-weight: 400;
            }
          }

          .card-body {
            padding: 0;

            ${(props) => props.theme.media.lg} {
              max-width: 265px;
              margin: auto;
            }
          }

          p {
            font-size: 14px;
            font-weight: 300;
            margin: 0;
            text-align: center;
            line-height: 24px;
          }
        }

        .card:nth-child(2),
        .card:nth-child(5) {
          ${(props) => props.theme.media.lg} {
            .card-body {
              max-width: 240px;
            }
          }
        }
      }
    }
  }

  section.blog {

    .container {
      max-width: 1200px;
    }
    .row {
      margin: 0 auto;
    }

    .blog-cards-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      ${(props) => props.theme.media.lg} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .blog-card:nth-child(2) {
        max-width: 360px;
        .title {
          ${(props) => props.theme.media.lg} {
            width: 360px;
            margin-bottom: 25px;
          }
        }
      }

      .blog-card {
        margin-top: 20px;
        margin-bottom: 15px;
        ${(props) => props.theme.media.lg} {
          display: flex;
          flex-direction: column;
          max-width: 350px;
          margin-bottom: 0px;
        }
      }

      .blog-link {
        ${(props) => props.theme.media.lg} {
          text-align: center;
        }
      }

      .title {
        margin-top: 20px;

        h3 {
          margin-bottom: 5px;
          line-height: 29px;
          color: #505050;
          font-weight: 500;
          width: 320px;

          ${(props) => props.theme.media.lg} {
            font-size: 24px;
            width: 100%;
          }
        }
      }

      .card-body {
        p {
          font-family: Inter;
          color: #626262;
          font-size: 16px;
          font-weight: 300;
    
          ${(props) => props.theme.media.lg} {
            line-height: 22px;
          }

        }
      }
    }
  }

  section.faqs {
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    ${(props) => props.theme.media.md} {
      padding-left: 0;
      padding-right: 0;
    }

    .row:nth-child(2) {
      border-top: 1px solid ${(props) => props.theme.gray300};
    }
  }

  section.contact {
    display: block;

    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .contact-title {
      font-family: Poppins;
      color: #3F5261;
      font-size: 28px;
      font-weight: 500;
      letter-spacing: 0px;
      ${(props) => props.theme.media.lg} {
        font-size: 40px;
      }
    }
    
    .contact-subtitle {
      font-family: Poppins;
      color: #3F5261;
      font-size: 28px;
      font-weight: 500;
      letter-spacing: 0px;
      ${(props) => props.theme.media.lg} {
        font-size: 30px;
      }
    }

    .btn {
      font-size: 1.5rem;
      margin-top: 32px;
      margin-top: 1rem;
      ${(props) => props.theme.media.lg} {
        margin-top: 3rem;
        font-size: 30px;
      }
    }
  }
`;

export default PayrollContentStyles;
